module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_8017.72a9fee4.png";